import { httpGet, httpGetFile } from './api.service';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { EquipmentPairing } from '../types/EquipmentPairing';
import { PaginatedResult } from '../types/PaginatedResult';

const getEquipmentPairings = async (model: PaginatedRequest): Promise<PaginatedResult<EquipmentPairing>> =>
  await httpGet<PaginatedResult<EquipmentPairing>>('api/equipment-pairing', model);
const exportEquipmentPairings = async (model: PaginatedRequest): Promise<void> => await httpGetFile('api/equipment-pairing/export', model);

export { getEquipmentPairings, exportEquipmentPairings };
